<boi-contextual-help-container [ngClass]="{'has-errors': hasErrors}" [contextualHelpName]="referenceDataLabels.IsMortgageClubSubmissionId">
  <boi-validation-error (errorChange)="hasErrors=$event" [propertyNames]="['Fee.SubmitViaMortgageClubCode']"></boi-validation-error>
  <kendo-textbox-container class="form-element app">
    <div class="form-label app" [boiRequiredFormField]="referenceDataLabels.IsMortgageClubSubmissionId">
      <label [for]="referenceDataLabels.IsMortgageClubSubmissionId" [innerHtml]="referenceDataLabels.IsMortgageClubSubmissionId |
                      localizeLabel"></label>
    </div>
    <div class="form-input-container">
      <div>
        <kendo-dropdownlist [data]="mortgageClubDataSource" valuePrimitive="true" textField="Value"
          id="referenceDataLabels.IsMortgageClubSubmissionId" valueField="Code" [(ngModel)]="application.Fee.SubmitViaMortgageClubCode"
          [disabled]="isFieldDisabled"
          [defaultItem]="{Value:referenceDataLabels.PleaseSelect | localizeLabel, Code: undefined}"
          (ngModelChange)="onMortgageClubCodeChange()">
        </kendo-dropdownlist>
      </div>
    </div>
    <boi-tooltip [tooltipName]="referenceDataLabels.IsMortgageClubSubmissionId"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>
